export const iconFontAwesomeShoppingCcMastercard = (
	<i className="fa-solid fa-cc-mastercard"></i>
);
